import React, {Component} from "react";
import {HashRouter, Route} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import {
  BASE_LINK,
  ROOM_FORM_LINK,
  ROOM_DETAIL_LINK,
  MY_RESERVE_LINK,
  MY_RESERVE_DETAIL_LINK,
  RESERVE_RESULT_LINK,
  ROOM_ARRANGE_LINK,
  ROOM_SEARCH_LINK,
  LOGIN_LINK,
  CHANGEPASSWORD, DP
} from "../actions/types";
import Index from "./Index";
import RoomDetail from "./RoomDetail";
import RoomFormSubmit from "./RoomFormSubmit";
import MyReserve from "./MyReserve";
import MyReserveDetail from "./MyReserveDetail";
import ReserveResult from "./ReserveResult";
import RoomArrangement from "./RoomArrangement";
import RoomSearch from "./RoomSearch";
import Login from "./Login";
import {withTheme} from "@material-ui/core/styles";
import RequireAuth from "./requireAuth";
import RequireAuthTips from "./requireAuthTips";
import ChangePassword from "./ChangePassword";

class App extends Component {
  render() {
    console.log(process.env.PUBLIC_URL);
    return (
      <HashRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <div className="App">
            <Route
              path={`${ROOM_FORM_LINK}`}
              component={RequireAuthTips(RoomFormSubmit)}
            />
            <Route path={`${ROOM_SEARCH_LINK}`} component={RoomSearch}/>
            <Route path={`${ROOM_DETAIL_LINK}/:id`} component={RoomDetail}/>
            <Route
              path={`${ROOM_ARRANGE_LINK}/:id`}
              component={RoomArrangement}
            />
            <Route
              path={`${MY_RESERVE_LINK}`}
              component={RequireAuth(MyReserve)}
            />
            <Route
              path={`${MY_RESERVE_DETAIL_LINK}/:id`}
              component={MyReserveDetail}
            />
            <Route path={`${RESERVE_RESULT_LINK}/:type/:code`} component={ReserveResult}/>
            <Route path={`${LOGIN_LINK}`} component={Login}/>
            <Route path={`${CHANGEPASSWORD}`} component={ChangePassword}/>
            <Route path={BASE_LINK} exact component={Index}/>
          </div>
        </ScrollToTop>
      </HashRouter>
    );
  }
}

export default withTheme()(App);
